const zh = {
    estateTeaser: {
        new: '新',
    },
    estateNavigation: {
        previous: '上一个',
        overview: '总览',
        next: '下一个',
    },
    estateSearch: {
        loading: '加载楼盘信息...',
        search: '搜素',
        emptyFilter: '清空搜素条件',
        noResults: '很抱歉没有搜素到您需要的信息.',
        noResultsCTA: '没有找到合适的信息?',
        noResultsCTADescription: '请注册邮箱，方便接收您需要的楼盘信息',
        noResultsCTAButton: '注册',
        cheapestFirst: '低价优先',
        mostExpensiveFirst: '高价优先',
        oldestFirst: '时间顺序',
        newestFirst: '时间逆序',
        result: '结果',
        results: '结果',
        showMap: '显示地图',
        hideMap: '隐藏地图',
        found: '发现',
        sortBy: '排序',
        selected: '选定',
    },
    estimateForm: {
        fields: {
            firstName: '名',
            lastName: '姓',
            purpose: '业务种类',
            purposeOptions: {
                forSale: '出售',
                forRent: '出租',
            },
            category: '房产种类',
            categoryOptions: {
                house: '住房',
                appartment: '公寓',
                ground: '地盘',
                office: '办公室',
                commercial: '商业盘',
                industrial: '工业盘',
                parkingOrGarage: '停车位',
            },
            mobile: '电话号码',
            email: '电子邮箱',
            street: '街道',
            number: '号码',
            box: '房号',
            postalCode: '邮政编码',
            city: '城镇',
        },
        validation: {
            firstName: '名',
            lastName: '姓',
            purpose: '业务种类',
            category: '房产种类',
            mobile: '电话',
            email: '电子邮箱',
            street: '街道',
            number: '号码',
            box: '房号',
            postalCode: '邮政编码',
            city: '城镇',
        },
        submit: '发送',
    },
    estateSearchForm: {
        title: '您的期待',
        contactTitle: '您的联系信息',
        fields: {
            purpose: '业务种类',
            minPrice: '最低价位',
            maxPrice: '最高价位',
            locations: '城镇区域',
            minBedrooms: '最低卧室数量',
            subCategories: '分类',
            firstName: '名',
            lastName: '姓',
            email: '电子邮箱',
            mobile: '电话号码',
        },
        validation: {
            purpose: '业务种类',
            firstName: '名',
            lastName: '姓',
            email: '电子邮箱',
            mobile: '电话号码',
            subCategories: '分类',
            minPrice: '最低价位',
            maxPrice: '最高价位',
            locations: '城镇区域',
            minBedrooms: '最低卧室数量',
        },
        submit: '请及时通知',
    },
};

export { zh };
